import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  getBogies,
  addBogie,
  editBogie,
  removeBogie,
  toggleBogieActive,
} from "../actions/bogieActions";
import {
  Box,
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControlLabel,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
  IconButton,
  Grid,
  Container,
  TablePagination,
  Card,
  CardContent,
  Tooltip,
  Slide,
  Switch,
  Divider,
  Snackbar,
} from "@material-ui/core";
import { Alert } from "@material-ui/lab";
import {
  Add,
  Edit,
  Delete,
  Train,
  EventSeat,
  Star,
  Close,
} from "@material-ui/icons";
import { makeStyles } from "@material-ui/core/styles";
import AdminVipSeatSelector from "./AdminVipSeatSelector.js";

const initialForm = {
  name: "",
  totalSeats: "",
  vipSeats: "",
  isActive: true,
};

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(2.5, 2),
    backgroundColor: "#f5f7fa",
    minHeight: "calc(100vh - 61px)",
    marginLeft: "5rem",
    width: "calc(100% - 5rem)",
    boxSizing: "border-box",
    [theme.breakpoints.down("sm")]: {
      marginLeft: 0,
      width: "100%",
      padding: theme.spacing(1.5, 1),
    },
  },
  headerCard: {
    background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
    color: "white",
    marginBottom: theme.spacing(2),
    borderRadius: theme.spacing(2),
    boxShadow: "0 8px 32px rgba(0,0,0,0.1)",
  },
  headerContent: {
    padding: theme.spacing(2, 2.5),
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    flexWrap: "wrap",
    gap: theme.spacing(2),
    [theme.breakpoints.down("sm")]: {
      padding: theme.spacing(1.5),
      gap: theme.spacing(1.25),
    },
  },
  title: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1),
    fontWeight: 600,
    fontSize: "1.8rem",
    [theme.breakpoints.down("sm")]: {
      fontSize: "1.3rem",
    },
  },
  addButton: {
    backgroundColor: "rgba(255,255,255,0.2)",
    color: "white",
    borderRadius: theme.spacing(3),
    padding: theme.spacing(1, 2.25),
    boxShadow: "0 4px 15px rgba(0,0,0,0.2)",
    transition: "all 0.3s ease",
    "&:hover": {
      backgroundColor: "rgba(255,255,255,0.3)",
      transform: "translateY(-2px)",
      boxShadow: "0 6px 20px rgba(0,0,0,0.3)",
    },
    [theme.breakpoints.down("sm")]: {
      width: "100%",
    },
  },
  tableContainer: {
    borderRadius: theme.spacing(2),
    boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
    overflowX: "auto",
  },
  table: {
    minWidth: 720,
    [theme.breakpoints.down("sm")]: {
      minWidth: 620,
    },
  },
  tableHeader: {
    background: "#fff7ef",
    "& th": {
      color: "#111827",
      fontWeight: 600,
      fontSize: "0.9rem",
      padding: theme.spacing(1.5),
    },
  },
  tableRow: {
    transition: "all 0.2s ease",
    "&:hover": {
      backgroundColor: "rgba(102, 126, 234, 0.04)",
      transform: "scale(1.001)",
    },
  },
  tableCell: {
    padding: theme.spacing(1.25, 1.5),
    borderBottom: "1px solid rgba(0,0,0,0.05)",
    [theme.breakpoints.down("sm")]: {
      padding: theme.spacing(1),
    },
  },
  statusChip: {
    fontWeight: 600,
    minWidth: 80,
    borderRadius: theme.spacing(2),
  },
  activeChip: {
    backgroundColor: "#4caf50",
    color: "white",
    "&:hover": {
      backgroundColor: "#43a047",
    },
  },
  inactiveChip: {
    backgroundColor: "#f44336",
    color: "white",
    "&:hover": {
      backgroundColor: "#e53935",
    },
  },
  actionButton: {
    margin: theme.spacing(0, 0.5),
    padding: theme.spacing(1),
    borderRadius: theme.spacing(1),
    transition: "all 0.2s ease",
    "&:hover": {
      transform: "scale(1.1)",
    },
  },
  editButton: {
    color: "#2196f3",
    "&:hover": {
      backgroundColor: "rgba(33, 150, 243, 0.1)",
    },
  },
  deleteButton: {
    color: "#f44336",
    "&:hover": {
      backgroundColor: "rgba(244, 67, 54, 0.1)",
    },
  },
  dialog: {
    "& .MuiDialog-paper": {
      borderRadius: theme.spacing(2),
      minWidth: "500px",
      maxWidth: "600px",
      [theme.breakpoints.down("sm")]: {
        minWidth: "calc(100vw - 24px)",
        margin: theme.spacing(1),
      },
    },
  },
  dialogTitle: {
    background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
    color: "white",
    padding: theme.spacing(2, 3),
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  dialogContent: {
    padding: theme.spacing(3),
    backgroundColor: "#fafafa",
    [theme.breakpoints.down("sm")]: {
      padding: theme.spacing(2),
    },
  },
  formField: {
    marginBottom: theme.spacing(2),
    "& .MuiOutlinedInput-root": {
      borderRadius: theme.spacing(1),
      transition: "all 0.2s ease",
      "&:hover": {
        boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
      },
      "&.Mui-focused": {
        boxShadow: "0 4px 12px rgba(102, 126, 234, 0.2)",
      },
    },
  },
  formActions: {
    padding: theme.spacing(2, 3),
    backgroundColor: "#f5f5f5",
    gap: theme.spacing(1),
  },
  submitButton: {
    borderRadius: theme.spacing(3),
    padding: theme.spacing(1.5, 3),
    background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
    color: "white",
    fontWeight: 600,
    "&:hover": {
      background: "linear-gradient(135deg, #5a6fd8 0%, #6a4190 100%)",
    },
  },
  cancelButton: {
    borderRadius: theme.spacing(3),
    padding: theme.spacing(1.5, 3),
    color: "#666",
    borderColor: "#ddd",
  },
  statsContainer: {
    display: "grid",
    gridTemplateColumns: "repeat(4, minmax(0, 1fr))",
    gap: theme.spacing(1.5),
    marginBottom: theme.spacing(2),
    [theme.breakpoints.down("md")]: {
      gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
    },
    [theme.breakpoints.down("xs")]: {
      gridTemplateColumns: "1fr",
    },
  },
  statCard: {
    background: "linear-gradient(135deg, #ff9a9e 0%, #fecfef 100%)",
    color: "white",
    padding: theme.spacing(1.5),
    borderRadius: theme.spacing(2),
    textAlign: "center",
    boxShadow: "0 4px 15px rgba(0,0,0,0.1)",
  },
  errorAlert: {
    marginBottom: theme.spacing(2),
    borderRadius: theme.spacing(1),
  },
  seatInfo: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: theme.spacing(0.5),
    fontSize: "0.9rem",
    color: "#666",
  },
  deleteDialog: {
    "& .MuiDialog-paper": {
      borderRadius: theme.spacing(2),
      minWidth: "400px",
      maxWidth: "500px",
    },
  },
  deleteDialogTitle: {
    background: "linear-gradient(135deg, #f44336 0%, #d32f2f 100%)",
    color: "white",
    padding: theme.spacing(2, 3),
  },
  deleteDialogContent: {
    padding: theme.spacing(3),
  },
  deleteDialogActions: {
    padding: theme.spacing(2, 3),
    gap: theme.spacing(1),
  },
  deleteConfirmButton: {
    borderRadius: theme.spacing(3),
    padding: theme.spacing(1.5, 3),
    background: "linear-gradient(135deg, #f44336 0%, #d32f2f 100%)",
    color: "white",
    fontWeight: 600,
    "&:hover": {
      background: "linear-gradient(135deg, #d32f2f 0%, #b71c1c 100%)",
    },
  },
  snackbar: {
    "& .MuiSnackbarContent-root": {
      background: "linear-gradient(135deg, #4caf50 0%, #43a047 100%)",
      color: "white",
      borderRadius: theme.spacing(1),
      fontWeight: 500,
    },
  },
  statusCell: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: theme.spacing(0.75),
    flexWrap: "wrap",
  },
  actionsCell: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: theme.spacing(0.5),
  },
}));

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const BogieMaster = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { bogies } = useSelector((state) => state.bogieReducer);
  const [form, setForm] = useState(initialForm);
  const [editId, setEditId] = useState(null);
  const [openDialog, setOpenDialog] = useState(false);
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [bogieToDelete, setBogieToDelete] = useState(null);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(7);
  const [error, setError] = useState("");
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  const [vipSeatGroups, setVipSeatGroups] = useState([]);

  useEffect(() => {
    dispatch(getBogies());
  }, [dispatch]);

  const totalBogies = bogies.length;
  const activeBogies = bogies.filter((b) => b.isActive).length;
  const totalSeats = bogies
    .filter((b) => b.isActive)
    .reduce((sum, b) => sum + b.totalSeats, 0);
  const totalVipSeats = bogies
    .filter((b) => b.isActive)
    .reduce((sum, b) => sum + b.vipSeats, 0);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({
      ...prev,
      [name]:
        name === "totalSeats" || name === "vipSeats" ? Number(value) : value,
    }));
    setError("");
  };

  const resetAddForm = () => {
    setForm(initialForm);
    setVipSeatGroups([]);
    setError("");
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (form.vipSeats > form.totalSeats) {
      setError("VIP seats cannot exceed total seats");
      return;
    }
    if (!form.name.trim()) {
      setError("Bogie name is required");
      return;
    }
    // const vipSeatNumbers = vipSeatGroups.flatMap(g => g.seats);

    // const payload = {
    //   ...form,
    //   name: form.name.trim(),
    //   totalSeats: Number(form.totalSeats),
    //   // vipSeats: Number(form.vipSeats),
    //   vipSeats: vipSeatNumbers.length,
    //   vipSeatNumbers
    // };

    const vipSeatNumbers = vipSeatGroups.flatMap(g => g.seats);

    const payload = {
      ...form,
      name: form.name.trim(),
      totalSeats: Number(form.totalSeats),
      vipSeats: vipSeatNumbers.length,
      vipSeatGroups,        // 👈 ADD THIS
      vipSeatNumbers        // 👈 keep temporarily
    };


    if (editId) {
      dispatch(editBogie(editId, payload));
      setSnackbarMessage(`Bogie '${form.name}' updated successfully`);
    } else {
      dispatch(addBogie(payload));
      setSnackbarMessage(`Bogie '${form.name}' added successfully`);

      resetAddForm();
    }
    setSnackbarSeverity("success");
    setSnackbarOpen(true);
    handleCloseDialog();
  };

  // const handleEdit = (bogie) => {
  //   setForm({
  //     name: bogie.name,
  //     totalSeats: bogie.totalSeats,
  //     vipSeats: bogie.vipSeats,
  //     isActive: bogie.isActive,
  //   });
  //   setEditId(bogie.id);
  //   setOpenDialog(true);
  // };

  const handleEdit = (bogie) => {
    setForm({
      name: bogie.name,
      totalSeats: bogie.totalSeats,
      vipSeats: bogie.vipSeats,
      isActive: bogie.isActive,
    });

    // Assuming `bogie` is a single object from your bogies array
    setVipSeatGroups(
      Array.isArray(bogie.vipSeatGroups) && bogie.vipSeatGroups.length
        ? bogie.vipSeatGroups // Use the new format if already present
        : (bogie.vipSeatNumbers || []).length
        ? [{ type: "legacy", seats: bogie.vipSeatNumbers }] // fallback for old data
        : []
    );


    console.log("bogie :", bogie)

    setEditId(bogie.id);
    setOpenDialog(true);
  };

  const handleAdd = () => {
    setForm(initialForm);
    setEditId(null);
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
    setEditId(null);
    setForm(initialForm);
    setError("");
  };

  const handleDelete = (bogie) => {
    setBogieToDelete(bogie);
    setDeleteDialogOpen(true);
  };

  const handleConfirmDelete = () => {
    if (bogieToDelete) {
      dispatch(removeBogie(bogieToDelete.id));
      setSnackbarMessage(`Bogie '${bogieToDelete.name}' deleted successfully`);
      setSnackbarSeverity("success");
      setSnackbarOpen(true);
    }
    setDeleteDialogOpen(false);
    setBogieToDelete(null);
  };

  const handleCloseDeleteDialog = () => {
    setDeleteDialogOpen(false);
    setBogieToDelete(null);
  };

  const handleToggleActive = (bogie) => {
    const nextIsActive = !bogie.isActive;
    dispatch(toggleBogieActive(bogie.id));
    setSnackbarMessage(
      `Bogie '${bogie.name}' set to ${nextIsActive ? "active" : "inactive"}`
    );
    setSnackbarSeverity(nextIsActive ? "success" : "error");
    setSnackbarOpen(true);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
    setSnackbarMessage("");
  };

  console.log("bogies :", bogies)

  const generateSeatGrid = (totalSeats) => {
    const columns = 3;
    const rows = Math.ceil(totalSeats / columns);
    const grid = [];
  
    for (let row = 0; row < rows; row++) {
      const rowSeats = [];
      for (let col = 0; col < columns; col++) {
        const seatNo = row + col * rows + 1;
        if (seatNo <= totalSeats) {
          rowSeats.push(seatNo);
        }
      }
      grid.push(rowSeats);
    }
  
    return grid;
  };
  

  return (
    <Container maxWidth={false} className={classes.root}>
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={3000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        className={classes.snackbar}
      >
        <Alert onClose={handleSnackbarClose} severity={snackbarSeverity}>
          {snackbarMessage}
        </Alert>
      </Snackbar>
      {/* Header */}
      <Card className={classes.headerCard}>
        <CardContent className={classes.headerContent}>
          <Typography variant="h4" className={classes.title}>
            <Train />
            Bogie Management
          </Typography>
          <Button
            variant="contained"
            startIcon={<Add />}
            className={classes.addButton}
            onClick={handleAdd}
          >
            Add New Bogie
          </Button>
        </CardContent>
      </Card>

      {/* Stats Cards */}
      <Box className={classes.statsContainer}>
        <Card className={classes.statCard}>
          <Typography variant="h6">{totalBogies}</Typography>
          <Typography variant="body2">Total Bogies</Typography>
        </Card>
        <Card className={classes.statCard}>
          <Typography variant="h6">{activeBogies}</Typography>
          <Typography variant="body2">Active Bogies</Typography>
        </Card>
        <Card className={classes.statCard}>
          <Typography variant="h6">{totalSeats}</Typography>
          <Typography variant="body2">Total Seats</Typography>
        </Card>
        <Card className={classes.statCard}>
          <Typography variant="h6">{totalVipSeats}</Typography>
          <Typography variant="body2">VIP Seats</Typography>
        </Card>
      </Box>

      {/* Table */}
      <TableContainer component={Paper} className={classes.tableContainer}>
        <Table className={classes.table}>
          <TableHead className={classes.tableHeader}>
            <TableRow>
              <TableCell align="center">Sr No</TableCell>
              <TableCell align="left">Bogie Name</TableCell>
              <TableCell align="left">Total Seats</TableCell>
              <TableCell align="left">VIP Seats</TableCell>
              <TableCell align="center">Status</TableCell>
              <TableCell align="center">Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {bogies
              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map((bogie, idx) => (
                <TableRow key={bogie.id} className={classes.tableRow}>
                  <TableCell align="center" className={classes.tableCell}>
                    {page * rowsPerPage + idx + 1}
                  </TableCell>
                  <TableCell align="left" className={classes.tableCell}>
                    <Box display="flex" alignItems="center" gap={1}>
                      <Train color="primary" />
                      <Typography variant="subtitle1" fontWeight={600}>
                        {bogie.name}
                      </Typography>
                    </Box>
                  </TableCell>
                  <TableCell align="center" className={classes.tableCell}>
                    <Box className={classes.seatInfo}>
                      <EventSeat />
                      {bogie.totalSeats}
                    </Box>
                  </TableCell>
                  <TableCell align="center" className={classes.tableCell}>
                    <Box className={classes.seatInfo}>
                      <Star />
                      {bogie.vipSeats}
                    </Box>
                  </TableCell>
                  <TableCell align="center" className={classes.tableCell}>
                    <Box className={classes.statusCell}>
                      <Switch
                        checked={bogie.isActive}
                        onChange={() => handleToggleActive(bogie)}
                        color="primary"
                        inputProps={{
                          "aria-label": "toggle bogie active status",
                        }}
                      />
                      <Typography variant="body2">
                        {bogie.isActive ? "Active" : "Inactive"}
                      </Typography>
                    </Box>
                  </TableCell>
                  <TableCell align="center" className={classes.tableCell}>
                    <Box className={classes.actionsCell}>
                      <Tooltip title="Edit Bogie">
                        <IconButton
                          className={`${classes.actionButton} ${classes.editButton}`}
                          onClick={() => handleEdit(bogie)}
                        >
                          <Edit />
                        </IconButton>
                      </Tooltip>
                      <Tooltip title="Delete Bogie">
                        <IconButton
                          className={`${classes.actionButton} ${classes.deleteButton}`}
                          onClick={() => handleDelete(bogie)}
                        >
                          <Delete />
                        </IconButton>
                      </Tooltip>
                    </Box>
                  </TableCell>
                </TableRow>
              ))}
          </TableBody>
        </Table>
        <TablePagination
          rowsPerPageOptions={[7, 10, 25, 50]}
          component="div"
          count={bogies.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </TableContainer>

      {/* Add/Edit Dialog */}
      <Dialog
        open={openDialog}
        onClose={handleCloseDialog}
        TransitionComponent={Transition}
        className={classes.dialog}
        maxWidth="sm"
      >
        <DialogTitle disableTypography className={classes.dialogTitle}>
          <Box
            display="flex"
            alignItems="center"
            justifyContent="space-between"
            width="100%"
          >
            <Box display="flex" alignItems="center" gap={1}>
              <Train style={{ marginRight: 8 }} />
              <Typography variant="h6" style={{ fontWeight: 600 }}>
                {editId ? "Edit Bogie" : "Add New Bogie"}
              </Typography>
            </Box>
            <IconButton onClick={handleCloseDialog} style={{ color: "#fff" }}>
              <Close />
            </IconButton>
          </Box>
        </DialogTitle>
        <Divider />
        <form onSubmit={handleSubmit}>
          <DialogContent className={classes.dialogContent}>
            {error && (
              <Alert severity="error" className={classes.errorAlert}>
                {error}
              </Alert>
            )}
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <TextField
                  label="Bogie Name"
                  name="name"
                  value={form.name}
                  onChange={handleChange}
                  required
                  variant="outlined"
                  className={classes.formField}
                  placeholder="Enter bogie name"
                  fullWidth
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  label="Total Seats"
                  name="totalSeats"
                  type="number"
                  value={form.totalSeats}
                  onChange={handleChange}
                  inputProps={{ min: 1, max: 100 }}
                  required
                  variant="outlined"
                  className={classes.formField}
                  fullWidth
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  label="VIP Seats"
                  name="vipSeats"
                  type="number"
                  value={form.vipSeats}
                  onChange={handleChange}
                  inputProps={{ min: 0, max: form.totalSeats }}
                  required
                  variant="outlined"
                  className={classes.formField}
                  fullWidth
                  disabled
                />
              </Grid>
              <Grid>
                <AdminVipSeatSelector
                  totalSeats={form.totalSeats}
                  existingVipGroups={vipSeatGroups}
                  onChange={setVipSeatGroups}
                />
              </Grid>
              <Grid item xs={12}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={form.isActive}
                      onChange={() =>
                        setForm({ ...form, isActive: !form.isActive })
                      }
                      name="isActive"
                      color="primary"
                    />
                  }
                  label="Active Bogie"
                />
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions className={classes.formActions}>
            <Button
              onClick={handleCloseDialog}
              className={classes.cancelButton}
              variant="outlined"
            >
              Cancel
            </Button>
            <Button
              type="submit"
              variant="contained"
              className={classes.submitButton}
            >
              Save
            </Button>
          </DialogActions>
        </form>
      </Dialog>

      {/* Delete Confirmation Dialog */}
      <Dialog
        open={deleteDialogOpen}
        onClose={handleCloseDeleteDialog}
        TransitionComponent={Transition}
        className={classes.deleteDialog}
        maxWidth="sm"
      >
        <DialogTitle disableTypography className={classes.deleteDialogTitle}>
          <Box
            display="flex"
            alignItems="center"
            justifyContent="space-between"
            width="100%"
          >
            <Box display="flex" alignItems="center" gap={1}>
              <Delete style={{ marginRight: 8 }} />
              <Typography variant="h6" style={{ fontWeight: 600 }}>
                Confirm Delete
              </Typography>
            </Box>
            <IconButton
              onClick={handleCloseDeleteDialog}
              style={{ color: "#fff" }}
            >
              <Close />
            </IconButton>
          </Box>
        </DialogTitle>
        <Divider />
        <DialogContent className={classes.deleteDialogContent}>
          <DialogContentText>
            Are you sure you want to delete the bogie{" "}
            <strong>{bogieToDelete?.name}</strong>? This action cannot be
            undone.
          </DialogContentText>
        </DialogContent>
        <DialogActions className={classes.deleteDialogActions}>
          <Button
            onClick={handleCloseDeleteDialog}
            className={classes.cancelButton}
            variant="outlined"
          >
            Cancel
          </Button>
          <Button
            onClick={handleConfirmDelete}
            variant="contained"
            className={classes.deleteConfirmButton}
          >
            Delete
          </Button>
        </DialogActions>
      </Dialog>
    </Container>
  );
};

export default BogieMaster;
